"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.RoomHelperService = void 0;
var rxjs_1 = require("rxjs");
var model_1 = require("./model");
var http_1 = require("../../core/http");
var room_api_1 = require("./room.api");
var operators_1 = require("rxjs/operators");
var session_1 = require("../session");
var env_1 = require("../../env");
var fetchRoomsSearch$;
var fetchRoomDescription$;
var fetchSingleRoomDescription$;
var fetchGetRoomsSearch = function (sessionId, options) {
    if (options === void 0) { options = {}; }
    var headers = {
        'X-AVP-Properties': 'Description',
        'X-AVP-PictureTemplates': 'Original|XLarge',
        'X-AVP-DescriptionType': 'text/plain'
    };
    var fetchData = http_1.Http.get(room_api_1.RoomApi.getSearch(sessionId), { headers: headers }).pipe(operators_1.map(function (response) {
        return __assign(__assign({}, response), { rooms: response.rooms.map(function (room) { return model_1.createRoomSearch(room); }) });
    }));
    if (options.preventShare) {
        return fetchData;
    }
    if (!fetchRoomsSearch$) {
        fetchRoomsSearch$ = fetchData.pipe(operators_1.share());
    }
    return fetchRoomsSearch$;
};
var fetchGetRoomDescription = function (sessionId, roomId) {
    if (!fetchSingleRoomDescription$) {
        fetchSingleRoomDescription$ = http_1.Http.get(room_api_1.RoomApi.getRoomDescription(sessionId, roomId)).pipe(operators_1.share(), operators_1.map(function (roomResponse) { return roomResponse; }));
    }
    return fetchRoomDescription$;
};
var fetchGetRoomsDescription = function (sessionId) {
    if (!fetchRoomDescription$) {
        fetchRoomDescription$ = http_1.Http.get(room_api_1.RoomApi.getDescription(sessionId)).pipe(operators_1.share(), operators_1.map(function (response) { return response.rooms.map(function (room) { return model_1.createRoomDescription(room); }); }));
    }
    return fetchRoomDescription$;
};
var getRoomsSearch = function (sessionId, options) {
    if (options === void 0) { options = {}; }
    return fetchGetRoomsSearch(sessionId, options).pipe(operators_1.catchError(session_1.SessionService.shouldBeSessionError));
};
var getRoomDescription = function (sessionId, roomId) {
    return fetchGetRoomDescription(sessionId, roomId).pipe(operators_1.catchError(session_1.SessionService.shouldBeSessionError));
};
var getRoomsDescription = function (sessionId) {
    return fetchGetRoomsDescription(sessionId).pipe(operators_1.catchError(session_1.SessionService.shouldBeSessionError));
};
var fetchRoom = function (sessionId, roomId) {
    return getRoomDescription(sessionId, roomId);
};
var fetchRooms = function (sessionId) {
    return rxjs_1.zip(getRoomsDescription(sessionId), getRoomsSearch(sessionId));
};
var getRoomsSearchForSpecificStayPeriod = function (stayPeriod, currency) {
    return session_1.SessionService.fetchCreateSession({
        context: { stayPeriod: stayPeriod, guests: undefined, selectedHotelId: env_1.Env.HotelId },
        display: { currency: currency, countryCode: env_1.Env.Country, culture: env_1.Env.DefaultLanguage }
    }, { preventShare: true }).pipe(operators_1.switchMap(function (createdSession) { return session_1.SessionService.fetchGetSession(createdSession.sessionId, { preventShare: true }); }), operators_1.switchMap(function (getSession) { return exports.RoomHelperService.getRoomsSearch(getSession.sessionId, { preventShare: true }); }), operators_1.map(function (res) { return res.rooms.reduce(function (acc, room) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[room.roomId] = model_1.RoomHelper.getCheapestPrice(room), _a));
    }, {}); }), operators_1.catchError(function (err) {
        console.log(err);
        return rxjs_1.of({});
    }));
};
var formatPricesForStayPeriods = function (stayPeriods, prices) {
    var formattedObjectByPeriods = stayPeriods.reduce(function (acc, stayPeriod, index) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a["" + stayPeriod.arrivalDate] = prices[index], _a));
    }, {});
    var pricesLength = prices.map(function (p) { return Object.keys(p).length; });
    var indexMaxPricesLength = pricesLength.indexOf(Math.max.apply(Math, pricesLength));
    return Object.keys(prices[indexMaxPricesLength]).reduce(function (acc, roomId) {
        var _a;
        var pricesByPeriod = Object.keys(formattedObjectByPeriods)
            .reduce(function (obj, period) {
            var _a;
            return (__assign(__assign({}, obj), (_a = {}, _a[period] = formattedObjectByPeriods[period][roomId], _a)));
        }, {});
        return __assign(__assign({}, acc), (_a = {}, _a[roomId] = pricesByPeriod, _a));
    }, {});
};
var resetCacheFetchRooms = function () {
    fetchRoomsSearch$ = null;
    fetchRoomDescription$ = null;
};
exports.RoomHelperService = {
    getRoomsSearch: getRoomsSearch,
    getRoomsDescription: getRoomsDescription,
    getRoomsSearchForSpecificStayPeriod: getRoomsSearchForSpecificStayPeriod,
    formatPricesForStayPeriods: formatPricesForStayPeriods,
    fetchRoom: fetchRoom,
    fetchRooms: fetchRooms,
    resetCacheFetchRooms: resetCacheFetchRooms
};
//# sourceMappingURL=room-helper.service.js.map